import Radio from '@mui/material/Radio'
import {
    GridSlotProps,
} from '@mui/x-data-grid-pro'

const GridRadioCell = ({
    checked,
    onChange,
    disabled,
}: GridSlotProps['baseCheckbox']) => {
    return (
        <Radio
            onChange={onChange}
            checked={checked}
            disabled={disabled}
            name="data-grid-radio"
        />
    )
}

export default GridRadioCell
